// Mixin para mensagens customizadas usando sistema próprio
export default {
  methods: {
    /**
     * Exibe mensagem de sucesso personalizada
     * @param {string} message - Mensagem a ser exibida
     * @param {number} duration - Duração em ms (padrão: 4000)
     */
    showSuccessMessage(message, duration = 4000) {
      return this.$notify.success(message, duration)
    },

    /**
     * Exibe mensagem de erro personalizada
     * @param {string} message - Mensagem a ser exibida
     * @param {number} duration - Duração em ms (padrão: 6000)
     */
    showErrorMessage(message, duration = 6000) {
      return this.$notify.error(message, duration)
    },

    /**
     * Exibe mensagem de warning personalizada
     * @param {string} message - Mensagem a ser exibida
     * @param {number} duration - Duração em ms (padrão: 5000)
     */
    showWarningMessage(message, duration = 5000) {
      return this.$notify.warning(message, duration)
    },

    /**
     * Exibe mensagem de info personalizada
     * @param {string} message - Mensagem a ser exibida
     * @param {number} duration - Duração em ms (padrão: 4000)
     */
    showInfoMessage(message, duration = 4000) {
      return this.$notify.info(message, duration)
    },

    /**
     * Limpa todas as mensagens
     */
    clearMessages() {
      return this.$notify.clear()
    }
  }
}